import { Component, Input, Output } from "@angular/core";
import { EventEmitter } from "@angular/core";

 
@Component({
  // tslint:disable-next-line:component-selector
  selector: "contact-chip",
  templateUrl: "contact-chip.component.html"
})
export class ContactChipComponent {
  @Input() public idContact: string;

  @Input() public image: string;

  @Input() public address: string;

  @Input() public name: string;

  @Output() public onClick: EventEmitter<any> = new EventEmitter<any>();

  @Output() public onRemove: EventEmitter<any> = new EventEmitter<any>();

  @Output() public onSposta: EventEmitter<any> = new EventEmitter<any>();

  public click(value: any) {
    this.onClick.emit(value.target.attributes[2].value);
  }

  public remove(value: any) {
    console.log("contact-chip remove", value);
    this.onRemove.emit(value.target.attributes[2].value);
  }

  public sposta(value: any) {
    console.log("contact-chip sposta", value.target.attributes);
    this.onSposta.emit(value.target.attributes[2].value);
  }
}

